import { render, staticRenderFns } from "./ErrorMsgSystem.vue?vue&type=template&id=5271bb8c&"
import script from "./ErrorMsgSystem.vue?vue&type=script&lang=js&"
export * from "./ErrorMsgSystem.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMsgSystem.vue?vue&type=style&index=0&id=5271bb8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports